import { useQueryClient } from '@tanstack/react-query';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { stopRentingAsset } from '@api/assetsRent';

import { IStopRentingAssetDTO } from '@interfaces/rent/dto/assetRentDTO';

import { ESnackbarTypes } from '@enums/common';

import { ACQUIRED_ASSETS, ASSET_PROFILE_OUTGOING_REQUESTS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import { useMutation } from '../reactQuery';

export const useMutateStopRentingAsset = () => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleStopRentingAsset,
		isLoading: isLoadingStopRentingAsset,
	} = useMutation<IStopRentingAssetDTO>({
		mutationKey: [ASSET_PROFILE_OUTGOING_REQUESTS],
		mutationFn: stopRentingAsset,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.stopRentingAsset,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([ASSET_PROFILE_OUTGOING_REQUESTS]),
				queryClient.invalidateQueries([ACQUIRED_ASSETS]),
			];
		},
	});

	return {
		handleStopRentingAsset,
		isLoadingStopRentingAsset,
	};
};
